import * as Yup from 'yup';

import { QuotationHeaderSchema } from '../../QuotationHeader/schemas/quotation-header.schema';
import { FormVariant } from '../../enums/variant.enum';

interface QuotationWorkflowLike {
  readonly _id: unknown;
  readonly initAction: Readonly<{
    settings: Readonly<{ autoCreateDocumentIfNotExists: boolean | null }>;
  }>;
}

export const getMissionQuotationInfoSchema = (
  formVariant: FormVariant,
  quotationWorkflows: readonly QuotationWorkflowLike[],
) =>
  Yup.lazy((values: { info?: { workflowId?: unknown } }) => {
    const willCreateDocumentImmediately =
      formVariant === FormVariant.Creation &&
      !!quotationWorkflows.find(
        (workflow) => workflow._id === values.info?.workflowId,
      )?.initAction.settings.autoCreateDocumentIfNotExists;

    const isTitleRequired =
      formVariant === FormVariant.Modification || willCreateDocumentImmediately;

    return Yup.object().shape({
      title: isTitleRequired
        ? Yup.string().required('Le titre est requis')
        : Yup.string().optional(),
      info: Yup.object().shape({
        header: QuotationHeaderSchema,
      }),
    });
  });
